import React, { Fragment } from 'react'
import Helmet from 'react-helmet'
import Link from 'gatsby-link'
import Header from '../../components/Header'
import hero from '../../images/special-groups__hero.jpg'
import img01 from '../../images/special-groups-1.jpg'
import img02 from '../../images/special-groups-2.jpg'
import img03 from '../../images/special-groups-3.jpg'

const Page = () => (
  <Fragment>
    <Helmet
      title="Group Travel | What We Offer"
      // meta={[{ name: 'description', content: '' }]}
    />
    <Header hero={hero}>
      <h1 className="t-hero">Group Travel</h1>
    </Header>
    <main id="content">
      <div className="c-golden t-context--light">
        <div className="c-golden__images c-golden__short min-laptop">
          <img src={img01} alt="" style={{ width: '50%', height: '50%' }} />
          <img src={img02} alt="" style={{ width: '50%', height: '50%' }} />
          <img src={img03} alt="" style={{ width: '100%', height: '50%' }} />
        </div>
        <div className="c-golden__content c-golden__wide">
          <ul className="c-breadcrumbs mb30">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/what-we-offer">What We Offer</Link>
            </li>
            <li>
              <Link
                to="/what-we-offer/special-groups"
                activeClassName="is-active"
              >
                Group Travel
              </Link>
            </li>
          </ul>
          <div className="c-golden__text">
            <div className="c-golden__text-col">
              <h1 className="t-h1">
              North America’s Group Travel Experts
              </h1>
              <p className="t-p t-p-light mt30">
              With a network of group travel experts strategically based across the continent, 
              ATI is uniquely qualified to plan and coordinate your special event in any North 
              American destination. For groups of 20 to 2,000 or more, ATI will design a custom 
              itinerary, including anything from hotel accommodations to themed events, 
              transportation to top line entertainment. With our team’s expertise and relationships, 
              the possibilities are endless for your group experience in North America. For all 
              Special Group, Event, and Incentive inquires please reach out to us at{' '}
                <a
                  className="t-red t-bold"
                  href="mailto:groupslax@americantours.com"
                >
                  groupslax@americantours.com
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </main>
  </Fragment>
)

export default Page



// WEBPACK FOOTER //
// ./src/pages/what-we-offer/group-travel.js